import { adminCall, adminGet } from './adminCall';

export async function fetchAdminMe() {
  return adminGet('/api/admin/me');
}

export async function updateAdminMe(payload) {
  const data = await adminCall('/api/admin/me', payload || {});
  if (!data?.success) throw new Error(data?.error || 'Failed to update profile');
  return data;
}

export async function updateAdminSecurity(payload) {
  const data = await adminCall('/api/admin/me/security', payload || {});
  if (!data?.success) throw new Error(data?.error || 'Failed to update setting');
  return data;
}

export async function markAdminChallenge(challengeId) {
  const data = await adminCall('/api/admin/me/challenge', { challengeId });
  if (!data?.success) throw new Error(data?.error || 'Failed to record verification');
  return data;
}
